import React from 'react';
import { ImportCreateTemplate } from 'themes/application/import/pages';
import { observer } from 'mobx-react';
import { ImportCreateViewStore } from 'application/import/stores';
import { setCurrentView } from 'core/utils';

@setCurrentView((rootStore) => new ImportCreateViewStore(rootStore), 'editView')
@observer
class ImportCreate extends React.Component {
    render() {
        return <ImportCreateTemplate {...this.props} />
    }
}

export default ImportCreate;